// store/Reducers/blogClientReducer.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { base_url } from '../../utils/config';

// 1) Fetch all blogs (with optional category & searchValue)
export const get_blogs = createAsyncThunk(
  'blogClient/get_blogs',
  async ({ category, searchValue }, { rejectWithValue }) => {
    try {
      let url = `${base_url}/api/blogs-get?`;
      if (category) url += `category=${category}&`;
      if (searchValue) url += `searchValue=${searchValue}&`;

      const { data } = await axios.get(url);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 2) Fetch single blog by ID
export const get_blog = createAsyncThunk(
  'blogClient/get_blog',
  async (blogId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${base_url}/api/blog-get/${blogId}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const blogClientSlice = createSlice({
  name: 'blogClient',
  initialState: {
    blogs: [],
    blog: null,
    loader: false,
    errorMessage: ''
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // get_blogs
      .addCase(get_blogs.pending, (state) => {
        state.loader = true;
      })
      .addCase(get_blogs.fulfilled, (state, action) => {
        state.loader = false;
        state.blogs = action.payload.blogs || [];
      })
      .addCase(get_blogs.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.error || 'Failed to fetch blogs.';
      })

      // get_blog
      .addCase(get_blog.pending, (state) => {
        state.loader = true;
      })
      .addCase(get_blog.fulfilled, (state, action) => {
        state.loader = false;
        state.blog = action.payload.blog || null;
      })
      .addCase(get_blog.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.error || 'Failed to fetch blog.';
      });
  }
});

export default blogClientSlice.reducer;
